<template>
  <div>
    <app-fes-header></app-fes-header>
    <slot></slot>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { throttle } from 'throttle-debounce'
import AppFesHeader from './AppFesHeader'
import fetchAccountData from '@/utils/fetchAccountData'
import * as types from '@/utvStore/store/mutation-types'

export default {
  name: 'appFesContainer',
  props: {
    data: Object,
    tokenFlg: String,
    container: {
      type: Boolean,
      default: true
    }
  },
  components: {
    AppFesHeader,
  },
  computed: {
    ...mapGetters(['isLoggedIn']),
    ...mapState({
      accessToken: state => state.auth.accessToken
    })
  },
  mounted() {
    // ログインしている場合はユーザー情報を更新
    if (this.isLoggedIn) {
      fetchAccountData.getProfile(this.accessToken)
        .then()
        .catch(error => {
          // エラー処理 access_tokenの不整合の場合はフロント側ログアウト処理を行う
          this.$store.dispatch(types.LOGOUT)
        })
    }

    // スクロール情報を初期化
    this.$store.commit(types.RESET_SCROLL_TOP)
    this.startWatchingScroll()
    /**
     * フロント (LocalStorage) と サーバー(Session) でのログイン状態の不整合の解消
     * tokenFlg が0(Sessionにログイン情報がない)の場合フロントのログイン情報を削除する
     **/
    if (undefined !== typeof this.tokenFlg) {
      if (this.tokenFlg === '0' && this.isLoggedIn) {
        this.$store.dispatch(types.LOGOUT)
      } else if (this.tokenFlg == '1' && !this.isLoggedIn) {
        this.mismatch = true;
        // storageからもトークンを消す
        this.$store.dispatch(types.LOGOUT).then(() => {
          location.href = `/user/logout`
        })
      }
    }
  },
  methods: {
    startWatchingScroll: function() {
      document.addEventListener(
        'scroll',
        throttle(100, () => {
          const scrollTop =
            document.body.scrollTop || document.documentElement.scrollTop
          this.$store.commit(types.UPDATE_SCROLL_TOP, scrollTop)
        })
      )
    }
  }
}</script>

<style>

</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/uFes/components/AppFesContainer.vue